export default "__VITE_ASSET__fa443d90__"